import React, { useState } from 'react';
import { useGetIdentity } from 'react-admin';
import { Grid, Button, Box } from '@mui/material';
import { BasicInfo } from './components/BasicInfo';
import { AccountInfo } from './components/AccountInfo';
import { ChangePassword } from './dialog/ChangePassword';

export const Profile = () => {
  const { isLoading } = useGetIdentity();

  const [openPassword, setOpenPassword] = useState(false);

  const handleClickOpenPassword = () => setOpenPassword(true);
  const handleClosePassword = () => setOpenPassword(false);

  if (isLoading) {
    return null;
  }

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          mb: 3,
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Button
          variant="outlined"
          startIcon={
            <img
              src="/Assets/Icons/circle-password.svg"
              alt="Change Password"
              style={{ width: 18, height: 18 }}
            />
          }
          sx={{
            textTransform: 'none',
            color: '#fff',
            borderColor: 'rgba(255, 255, 255, 0.3)',
            '&:hover': {
              borderColor: 'rgba(255, 255, 255, 0.5)'
            }
          }}
          onClick={handleClickOpenPassword}
        >
          Change password
        </Button>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <BasicInfo />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <AccountInfo />
        </Grid>
      </Grid>

      <ChangePassword open={openPassword} onClose={handleClosePassword} />
    </Box>
  );
};

export default Profile;
